export class ConjuntoProyectoProyecto {
  idConjuntoProyecto: number = -1;
  idProyecto: number= -1;
}
